import { render, staticRenderFns } from "./TkBaggage.vue?vue&type=template&id=341226fe&"
import script from "./TkBaggage.vue?vue&type=script&lang=js&"
export * from "./TkBaggage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports